import PropTypes from 'prop-types';
import React from 'react';

const Haskell = ({ className }) => (
  <svg
    className={className}
    width="1731"
    height="857"
    viewBox="0 0 1731 857"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.08" cx="1605" cy="483" r="124" fill="url(#paint0_linear_1112_12845)" />
    <circle opacity="0.08" cx="1605" cy="483" r="104" fill="url(#paint1_linear_1112_12845)" />
    <mask
      id="mask0_1112_12845"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="1501"
      y="379"
      width="208"
      height="208"
    >
      <circle cx="1605" cy="483" r="104" fill="#181A1B" />
    </mask>
    <g mask="url(#mask0_1112_12845)">
      <g opacity="0.8">
        <path
          d="M1779.83 128.5L1712.57 167.33L1701.25 173.87L1689.6 180.59L1678.14 187.21L1666.57 193.89L1654.77 200.7L1643.2 207.38L1631.86 213.93L1620.29 220.61L1608.67 227.32L1597 234L1585.41 240.69L1573.81 247.38L1562.23 254.08C1558.36 256.3 1554.5 258.54 1550.64 260.76L1539.06 267.45L1527.48 274.14L1515.9 280.82L1504.31 287.51L1492.74 294.19L1481.15 300.88L1469.59 307.56L1458 314.29L1446.46 321L1434.88 327.68L1423.3 334.37L1411.74 341L1400.15 347.69L1388.58 354.38C1384.72 356.6 1380.86 358.84 1376.99 361.06L1365.42 367.75L1353.84 374.43L1342.26 381.12L1330.69 387.8L1319.1 394.5L1307.52 401.19L1295.94 407.87L1284.35 414.56L1272.77 421.25L1261.17 427.94L1249.57 434.64L1243.5 438.14"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1845.41 128.5L1745.41 186.26L1734 192.8L1722.35 199.53L1710.89 206.14L1699.32 212.82L1687.52 219.63L1676 226.31L1664.65 232.86L1653.08 239.54L1641.46 246.25L1629.82 253L1618.23 259.69L1606.63 266.39L1595.05 273.08L1583.46 279.76C1579.6 282 1575.74 284.23 1571.88 286.45L1560.3 293.14L1548.72 299.82L1537.13 306.51L1525.56 313.19L1514 319.85L1502.43 326.53L1490.85 333.22L1479.28 339.9C1475.42 342.127 1471.56 344.353 1467.69 346.58L1456.11 353.27L1444.53 360L1432.94 366.69L1421.37 373.37L1409.79 380L1398.21 386.68L1386.63 393.37L1375.05 400.05L1363.48 406.73L1351.9 413.42C1348.04 415.653 1344.18 417.88 1340.31 420.1L1328.73 426.8L1317.15 433.49L1305.56 440.19L1294 446.88L1282.4 453.57L1270.8 460.26C1266.9 462.5 1263.04 464.71 1259.22 466.7C1255.49 468.708 1251.6 470.423 1247.6 471.83C1246.25 472.291 1244.89 472.682 1243.5 473"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1929.44 534.371L1919.07 540.371L1907.48 547.001L1895.92 553.681L1884.33 560.371L1872.77 567.051C1868.9 569.271 1865.05 571.501 1861.18 573.741L1849.6 580.421L1838 587.141L1826.41 593.831L1814.84 600.511L1803.25 607.201L1791.68 613.871C1787.82 616.091 1783.96 618.284 1780.1 620.451C1776.24 622.601 1772.38 624.691 1768.52 626.791C1764.66 628.891 1760.85 631.001 1757 633.001C1753.15 635.001 1749.29 636.901 1745.42 638.871C1741.55 640.841 1737.71 642.871 1733.84 644.871C1729.97 646.871 1726.12 648.871 1722.26 651.011C1718.4 653.151 1714.53 655.281 1710.67 657.511C1706.81 659.741 1702.94 662.051 1699.08 664.441C1695.22 666.831 1691.34 669.331 1687.49 671.831L1675.89 679.361C1671.99 681.891 1668.12 684.361 1664.28 686.811C1660.44 689.261 1656.53 691.571 1652.71 693.861C1648.89 696.151 1644.95 698.521 1641.12 700.781C1637.29 703.041 1633.33 705.331 1629.51 707.531L1618 714.181L1606.5 720.821L1595 727.481L1583.27 734.251C1579.38 736.491 1575.54 738.711 1571.73 740.911L1560.28 747.521L1548.71 754.201L1537 760.931L1525.3 767.691C1521.39 769.951 1517.48 772.208 1513.56 774.461L1502.36 780.931L1444.36 814.441"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1929.44 496.5L1921 501.36L1909.42 508.05L1897.83 514.74L1886.25 521.42L1874.67 528.11L1863.1 534.79L1851.52 541.48L1840 548.16L1828.42 554.84L1816.84 561.53L1805.28 568.19C1801.41 570.423 1797.54 572.63 1793.68 574.81C1789.83 576.98 1785.98 579.11 1782.11 581.09C1778.24 583.07 1774.39 584.85 1770.53 586.44C1763.15 589.609 1755.35 591.732 1747.38 592.75C1743.52 593.29 1739.66 593.66 1735.79 593.89C1731.92 594.12 1728.09 594.22 1724.22 594.52C1720.33 594.802 1716.46 595.34 1712.64 596.13C1708.69 596.959 1704.81 598.048 1701 599.39C1697.05 600.793 1693.18 602.409 1689.41 604.23C1685.56 606.1 1681.69 608.23 1677.83 610.51C1673.97 612.79 1670.1 615.28 1666.24 618.03C1662.38 620.78 1658.5 623.85 1654.64 627.24C1650.78 630.63 1646.9 634.41 1643.05 638.39C1639.2 642.37 1635.28 646.68 1631.44 651.02C1627.6 655.36 1623.69 659.92 1619.86 664.11C1616.03 668.3 1612.11 672.32 1608.28 675.96C1604.45 679.6 1600.48 683.07 1596.67 686.13C1592.86 689.19 1588.97 692.04 1585.17 694.59C1581.37 697.14 1577.52 699.49 1573.67 701.79C1569.82 704.09 1566.06 706.27 1562.15 708.53C1558.24 710.79 1554.32 713.06 1550.42 715.31L1538.91 722L1527.46 728.61L1515.89 735.29L1504.23 742L1492.53 748.75L1480.79 755.53L1469.59 762L1378.76 814.45"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1929.44 318.709L1928.9 318.509C1925.15 317.022 1921.03 316.728 1917.11 317.669C1913.11 318.719 1909.3 321.299 1905.54 325.319C1901.78 329.339 1898 334.999 1894.2 341.069C1890.4 347.139 1886.57 353.679 1882.63 359.619C1879.18 364.932 1875.29 369.949 1871 374.619C1867.47 378.357 1863.57 381.73 1859.37 384.689C1855.52 387.439 1851.65 389.779 1847.77 392.079C1843.89 394.379 1840.05 396.589 1836.18 398.829L1824.59 405.529L1813 412.269L1801.43 418.999L1789.85 425.679C1785.98 427.909 1782.13 430.139 1778.26 432.359C1774.39 434.579 1770.53 436.789 1766.68 438.919C1762.83 441.049 1759 442.999 1755.11 444.779C1751.41 446.544 1747.52 447.886 1743.52 448.779C1739.71 449.537 1735.81 449.679 1731.96 449.199C1728.02 448.68 1724.14 447.792 1720.37 446.549C1716.59 445.2 1712.73 444.12 1708.8 443.319C1704.94 442.661 1700.97 442.904 1697.22 444.029C1692.97 445.388 1689.03 447.588 1685.64 450.499C1681.37 454.16 1677.5 458.251 1674.07 462.709C1670.22 467.569 1666.35 473.099 1662.49 478.709C1658.63 484.319 1654.78 489.979 1650.92 494.919C1647.36 499.485 1643.49 503.799 1639.33 507.829C1635.68 511.38 1631.82 514.7 1627.76 517.769C1623.9 520.679 1620.04 523.209 1616.18 525.619C1612.32 528.029 1608.46 530.299 1604.6 532.549C1600.74 534.799 1596.88 536.999 1593 539.269L1581.44 545.999L1569.86 552.689L1558.28 559.369L1546.69 565.999C1542.83 568.232 1538.97 570.462 1535.1 572.689C1531.23 574.929 1527.36 577.179 1523.51 579.249C1519.77 581.307 1515.89 583.115 1511.91 584.659C1508.22 586.176 1504.29 586.996 1500.3 587.079L1499.16 587.029"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1929.44 572.23L1928.71 572.66L1917.13 579.34L1905.56 586L1894 592.71L1882.41 599.39L1870.85 606.07L1859.26 612.76L1847.69 619.44L1836.11 626.13L1824.53 632.81L1812.95 639.5L1801.37 646.19L1789.79 652.86L1778.21 659.55L1766.64 666.23L1755 672.92L1743.42 679.61L1731.82 686.3L1720.26 693L1708.66 699.69L1697.05 706.4L1685.48 713.09L1673.9 719.77C1669.98 722.03 1666.1 724.28 1662.28 726.47L1650.78 733.11L1639.29 739.76C1635.49 741.94 1631.67 744.15 1627.76 746.41L1616 753.18L1604.46 759.84L1593 766.45L1581.44 773.13L1569.78 779.86L1558.07 786.62L1546.33 793.4L1535.13 799.86L1511.82 813.32"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1929.44 359.15L1926.99 363.15C1923.23 369.35 1919.37 375.74 1915.42 381.26C1911.98 386.143 1908.08 390.689 1903.79 394.84C1900.19 398.229 1896.3 401.294 1892.16 404C1888.31 406.57 1884.44 408.81 1880.56 411.07L1869 417.82L1857.41 424.51L1845.83 431.19C1841.97 433.43 1838.11 435.66 1834.25 437.88L1822.67 444.57L1811.09 451.25L1799.5 457.94L1787.93 464.61C1784.06 466.83 1780.2 469.04 1776.34 471.13C1772.48 473.22 1768.63 475.22 1764.78 476.94C1761.06 478.686 1757.18 480.059 1753.19 481.04C1749.4 481.925 1745.5 482.229 1741.62 481.94C1737.69 481.578 1733.8 480.865 1730 479.81C1726.13 478.81 1722.27 477.73 1718.41 477.07C1714.6 476.311 1710.67 476.29 1706.85 477.01C1702.66 478.009 1698.72 479.85 1695.26 482.42C1690.99 485.54 1687.11 489.152 1683.69 493.18C1679.83 497.59 1675.97 502.82 1672.1 508.25C1668.23 513.68 1664.39 519.31 1660.53 524.44C1656.94 529.258 1653.09 533.875 1649 538.27C1645.37 542.107 1641.51 545.707 1637.42 549.05C1633.71 552.082 1629.84 554.922 1625.84 557.56C1621.99 560.13 1618.13 562.48 1614.26 564.78C1610.39 567.08 1606.55 569.32 1602.69 571.56L1591.1 578.26L1579.48 585C1575.62 587.23 1571.76 589.46 1567.89 591.62C1564.02 593.78 1560.16 595.88 1556.3 597.57C1552.61 599.271 1548.71 600.481 1544.71 601.17C1543.92 601.29 1543.14 601.37 1542.36 601.43"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1929.44 420.17C1927.95 421.17 1926.44 422.17 1924.96 423.09C1921.1 425.52 1917.23 427.78 1913.36 430.09L1901.76 436.8L1890.17 443.49L1878.59 450.18L1867 456.82L1855.43 463.5L1843.84 470.19L1832.26 476.88L1820.68 483.55L1809.09 490.25L1797.53 496.92C1793.67 499.15 1789.8 501.39 1785.94 503.52C1782.08 505.65 1778.23 507.66 1774.37 509.52C1770.63 511.351 1766.76 512.912 1762.8 514.19C1759.05 515.396 1755.16 516.069 1751.22 516.19C1747.33 516.172 1743.44 515.716 1739.65 514.83C1735.79 514 1731.92 512.95 1728.06 512.13C1724.28 511.191 1720.39 510.81 1716.5 511C1712.44 511.415 1708.5 512.628 1704.91 514.57C1700.71 516.823 1696.82 519.61 1693.34 522.86C1689.19 526.755 1685.32 530.942 1681.76 535.39C1677.91 540.11 1674.04 545.29 1670.18 550.39C1666.32 555.49 1662.47 560.57 1658.6 565.15C1654.95 569.483 1651.08 573.622 1647 577.55C1643.32 581.1 1639.46 584.458 1635.43 587.61C1631.57 590.61 1627.71 593.29 1623.84 595.75C1619.97 598.21 1616.12 600.43 1612.25 602.54C1608.49 604.646 1604.62 606.549 1600.66 608.24L1599.71 608.63"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1894.09 302.271C1891.01 300.915 1887.68 300.233 1884.32 300.271C1880.32 300.461 1876.51 302.271 1872.75 305.331C1868.99 308.391 1865.22 312.951 1861.4 318.521C1857.58 324.091 1853.78 330.521 1849.83 336.761C1846.3 342.539 1842.42 348.096 1838.21 353.401C1834.73 357.646 1830.83 361.526 1826.57 364.981C1822.89 367.92 1819.03 370.622 1815 373.071C1811.14 375.481 1807.27 377.701 1803.41 379.941L1791.82 386.641L1780.24 393.331L1768.64 400.001C1764.77 402.211 1760.92 404.411 1757.06 406.541C1753.2 408.671 1749.33 410.761 1745.47 412.471C1741.74 414.146 1737.87 415.465 1733.89 416.411C1730.1 417.315 1726.21 417.675 1722.32 417.481C1718.37 417.161 1714.48 416.355 1710.73 415.081C1706.87 413.831 1703.01 412.251 1699.16 411.511C1695.32 410.749 1691.35 410.899 1687.58 411.951C1683.33 413.21 1679.39 415.338 1676 418.201C1671.71 421.84 1667.82 425.937 1664.42 430.421C1660.56 435.321 1656.7 440.941 1652.83 446.671C1648.96 452.401 1645.13 458.211 1641.27 463.231C1637.74 467.823 1633.87 472.139 1629.68 476.141C1626.05 479.634 1622.19 482.872 1618.11 485.831C1614.26 488.641 1610.4 491.061 1606.53 493.401C1602.66 495.741 1598.83 498.001 1595 500.271L1583.39 507.001L1571.8 513.691L1560.23 520.371L1548.65 527.001L1537.07 533.681L1525.48 540.371L1513.9 547.061L1502.31 553.751L1490.72 560.411C1486.83 562.641 1482.97 564.841 1479.12 566.751C1475.44 568.677 1471.55 570.145 1467.51 571.121C1463.84 571.927 1460.05 571.945 1456.37 571.171"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1794.24 279.479C1790.84 279.396 1787.46 279.907 1784.24 280.989C1780.12 282.437 1776.21 284.432 1772.62 286.919C1768.54 289.699 1764.66 292.756 1761 296.069C1757.15 299.509 1753.28 303.319 1749.41 306.829C1745.72 310.196 1741.85 313.351 1737.81 316.279C1734.15 318.937 1730.27 321.279 1726.22 323.279C1722.48 325.08 1718.61 326.601 1714.64 327.829C1710.77 329.059 1706.92 330.079 1703.06 331.149C1699.2 332.219 1695.34 333.339 1691.48 334.759C1687.49 336.224 1683.62 337.976 1679.89 339.999C1675.85 342.202 1671.98 344.699 1668.31 347.469C1664.21 350.573 1660.34 353.972 1656.73 357.639C1652.64 361.83 1648.77 366.232 1645.14 370.829C1641.28 375.649 1637.43 380.829 1633.58 385.829C1629.73 390.829 1625.85 395.659 1621.99 400.059C1618.37 404.241 1614.51 408.202 1610.42 411.919C1606.74 415.179 1602.88 418.224 1598.85 421.039C1594.99 423.779 1591.12 426.309 1587.26 428.709C1583.4 431.109 1579.56 433.379 1575.7 435.639L1564.11 442.349L1552.54 449.029L1541 455.739L1529.43 462.419L1517.85 469.109L1506.27 475.789C1502.41 478.009 1498.55 480.239 1494.7 482.479L1483.11 489.159L1471.53 495.849L1459.95 502.539L1448.36 509.219L1436.78 515.909L1425.18 522.599C1421.3 524.839 1417.43 527.069 1413.59 529.249C1409.75 531.429 1405.81 533.629 1401.98 535.379C1398.32 537.164 1394.42 538.407 1390.4 539.069C1387.01 539.538 1383.56 539.351 1380.24 538.519"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1929.44 155.721L1811 224.131L1799.67 230.661L1788 237.391L1776.51 244.001L1764.94 250.681L1753.15 257.481L1741.59 264.161L1730.24 270.651C1726.48 272.781 1722.62 274.971 1718.67 277.131C1714.72 279.291 1711 281.291 1707 283.401C1703 285.511 1699.27 287.561 1695.37 289.611C1691.47 291.661 1687.65 293.611 1683.77 295.681C1679.89 297.751 1676.05 299.821 1672.18 301.981C1668.31 304.141 1664.45 306.371 1660.59 308.681C1656.73 310.991 1652.87 313.381 1649.01 315.801C1645.15 318.221 1641.28 320.651 1637.43 323.081C1633.58 325.511 1629.7 327.911 1625.85 330.301C1622 332.691 1618.12 335.021 1614.26 337.301C1610.4 339.581 1606.53 341.941 1602.68 344.211C1598.83 346.481 1595 348.791 1591.15 351.001L1579.56 357.691L1568 364.391L1556.41 371.081L1544.84 377.771L1533.26 384.451L1521.68 391.141C1517.82 393.361 1513.98 395.591 1510.11 397.811L1498.53 404.501L1487 411.181L1475.41 417.871L1463.83 424.561L1452.26 431.241L1440.68 437.931L1429.1 444.611L1417.52 451.301L1405.9 458.001L1394.32 464.691L1382.73 471.381L1371.14 478.071L1359.55 484.761L1348 491.431C1344.1 493.691 1340.22 495.941 1336.39 498.041C1332.56 500.141 1328.64 502.191 1324.82 503.821C1321.15 505.505 1317.24 506.621 1313.23 507.131C1310.47 507.401 1307.69 507.198 1305 506.531"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1243.5 478.891C1249.02 481.521 1254.62 484.061 1260.19 486.561C1266.68 489.481 1273.19 492.361 1279.71 495.251C1285.71 497.931 1291.8 500.601 1297.83 503.321C1300.83 504.671 1303.83 506.031 1306.83 507.371C1309.83 508.711 1312.92 510.061 1315.98 511.371L1324.9 515.161L1334.19 519.161C1337.26 520.494 1340.33 521.791 1343.41 523.051C1346.41 524.321 1349.49 525.561 1352.53 526.821C1355.57 528.081 1358.7 529.381 1361.78 530.681C1364.86 531.981 1367.78 533.271 1370.78 534.561C1373.98 535.941 1377.19 537.307 1380.4 538.661C1383.3 539.881 1386.2 541.091 1389.08 542.341C1391.96 543.591 1394.54 544.741 1397.27 545.961C1400.42 547.371 1403.6 548.771 1406.77 550.151L1416.09 554.151L1425.41 558.241C1428.52 559.574 1431.63 560.907 1434.76 562.241C1437.7 563.501 1440.65 564.747 1443.6 565.981L1448.21 567.981C1449.65 568.581 1451.08 569.191 1452.53 569.751L1454.78 570.601L1457.22 571.521L1462.12 573.351L1471.71 576.941C1474.77 578.091 1477.84 579.261 1480.9 580.391C1483.96 581.521 1486.9 582.621 1489.9 583.701L1499.35 587.081C1502.5 588.211 1505.65 589.361 1508.8 590.481C1511.95 591.601 1515.17 592.741 1518.37 593.831C1521.57 594.921 1524.65 595.941 1527.8 596.971C1530.95 598.001 1533.87 598.971 1536.92 599.871"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1911 128.5L1778.15 205.19L1766.83 211.73L1755.18 218.46L1743.72 225.08L1732.15 231.75L1720.36 238.57L1708.79 245.24L1697.44 251.79L1685.88 258.47L1674.25 265.18L1662.61 271.9L1651 278.59L1639.41 285.29C1635.54 287.51 1631.67 289.74 1627.82 291.98L1616.24 298.67C1612.37 300.89 1608.51 303.13 1604.66 305.35L1593.09 312L1581.51 318.69L1569.93 325.38C1566.06 327.6 1562.2 329.823 1558.36 332.05L1546.77 338.75L1535.21 345.42L1523.62 352.11L1512.05 358.79L1500.47 365.48L1488.89 372.16L1477.32 378.84L1465.73 385.53L1454.17 392.21L1442.58 398.9L1431 405.62L1419.43 412.31L1407.85 419L1396.27 425.69L1384.69 432.37L1373.11 439.06C1369.25 441.28 1365.39 443.51 1361.53 445.75C1357.67 447.99 1353.81 450.22 1349.94 452.44L1338.35 459.13L1326.76 465.82L1315.16 472.52L1303.55 479.19C1299.65 481.43 1295.79 483.63 1291.97 485.52C1288.29 487.442 1284.41 488.945 1280.39 490C1276.59 490.984 1272.62 491.073 1268.78 490.26C1268.46 490.19 1268.15 490.11 1267.84 490.02"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1342.51 522.63C1343.65 522.92 1344.8 523.127 1345.97 523.25C1349.89 523.547 1353.84 523.051 1357.56 521.79C1361.56 520.487 1365.43 518.834 1369.13 516.85C1372.97 514.85 1376.85 512.61 1380.75 510.35C1384.65 508.09 1388.46 505.91 1392.34 503.68L1403.93 496.98L1415.52 490.29L1427.11 483.6L1438.69 476.91L1450.27 470.23L1461.85 463.54L1473.43 456.86L1485 450.18L1496.58 443.48L1508.15 436.81C1512.01 434.57 1515.88 432.34 1519.74 430.12L1531.31 423.44C1535.17 421.2 1539.04 418.97 1542.9 416.75L1554.46 410.07L1566.05 403.37C1569.9 401.14 1573.77 398.91 1577.62 396.63C1581.47 394.35 1585.33 392.03 1589.19 389.63C1593.05 387.23 1596.92 384.76 1600.78 382.14C1604.64 379.52 1608.48 376.78 1612.34 373.84C1616.2 370.9 1620.06 367.77 1623.93 364.38C1627.8 360.99 1631.64 357.38 1635.51 353.64C1639.38 349.9 1643.22 346.05 1647.09 342.24C1650.96 338.43 1654.81 334.66 1658.67 330.79C1662.53 326.92 1666.39 322.97 1670.25 319.37C1674.11 315.77 1677.96 312.56 1681.83 309.5C1685.7 306.44 1689.55 303.57 1693.41 301.02C1697.14 298.569 1701.01 296.335 1705 294.33C1708.52 292.525 1712.16 290.952 1715.88 289.62L1717.11 289.19C1720.11 288.19 1723.21 287.19 1726.27 286.38C1729.33 285.57 1732.19 284.87 1735.12 284.24C1737.01 283.85 1738.93 283.47 1740.82 283.14C1745.06 282.38 1749.4 281.74 1753.82 281.26C1756.15 281.01 1758.4 280.8 1760.73 280.63C1763.44 280.44 1766.21 280.28 1768.92 280.15H1769.33L1771.09 280.08C1771.67 280.08 1772.25 280.02 1772.83 279.99L1774.6 279.91C1777.69 279.77 1780.93 279.63 1784.03 279.54C1787.13 279.45 1790.03 279.43 1792.97 279.48C1794.53 279.48 1796.08 279.56 1797.63 279.63C1800.43 279.76 1803.26 279.97 1806.05 280.22C1808.84 280.47 1811.44 280.74 1814.1 281.04C1817.26 281.4 1820.38 281.8 1823.51 282.23C1826.8 282.7 1830.22 283.23 1833.51 283.78C1838.73 284.68 1844.44 285.78 1849.73 287.05"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1929.44 318.479C1924.99 316.479 1912.71 310.559 1900.44 305.069L1899.09 304.469L1895.54 302.899H1895.43L1894.89 302.659C1891.42 301.152 1887.93 299.699 1884.42 298.299C1879.22 296.232 1873.97 294.322 1868.67 292.569C1864.19 291.089 1859.32 289.569 1854.67 288.319L1851.67 287.549L1849.87 287.119C1846.62 286.259 1843.21 286.163 1839.92 286.839C1835.68 287.917 1831.77 290.049 1828.57 293.039C1824.24 296.991 1820.36 301.412 1817 306.219C1813.2 311.469 1809.32 317.599 1805.38 323.219C1801.54 328.719 1797.65 333.789 1793.74 338.369C1790.16 342.633 1786.29 346.643 1782.15 350.369C1778.49 353.552 1774.62 356.476 1770.55 359.119C1766.69 361.659 1762.83 363.959 1758.97 366.119C1755.11 368.279 1751.24 370.119 1747.38 371.899C1743.61 373.66 1739.74 375.209 1735.8 376.539C1732.02 377.757 1728.15 378.667 1724.22 379.259C1720.39 379.87 1716.52 380.164 1712.64 380.139C1708.76 380.07 1704.89 379.736 1701.06 379.139C1697.23 378.439 1693.37 377.998 1689.48 377.819C1685.54 377.828 1681.62 378.504 1677.9 379.819C1673.73 381.205 1669.83 383.295 1666.37 385.999C1662.07 389.546 1658.18 393.572 1654.79 397.999C1650.92 402.859 1647.07 408.449 1643.22 414.049C1639.37 419.649 1635.5 425.249 1631.64 430.239C1628.08 434.891 1624.21 439.297 1620.05 443.429C1616.44 446.998 1612.58 450.303 1608.49 453.319C1604.63 456.169 1600.76 458.649 1596.9 461.029C1593.04 463.409 1589.19 465.669 1585.33 467.929C1581.47 470.189 1577.61 472.409 1573.74 474.639L1562.18 481.319L1550.59 487.999L1539 494.729L1527.43 501.399L1515.85 508.089L1504.26 514.779C1500.41 517.012 1496.55 519.239 1492.68 521.459C1488.81 523.679 1484.94 525.909 1481.09 528.149L1469.51 534.849L1457.91 541.539C1454.03 543.779 1450.16 546.019 1446.32 548.089C1442.59 550.18 1438.71 551.989 1434.71 553.499C1431.02 554.929 1427.09 555.638 1423.13 555.589C1421.16 555.505 1419.2 555.196 1417.3 554.669"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1247.61 814.439L1404 724.129L1415.19 717.659L1426.93 710.889L1438.64 704.129L1450.3 697.399L1461.86 690.719C1465.73 688.479 1469.51 686.299 1473.31 684.039C1477.11 681.779 1480.96 679.419 1484.85 676.709C1489.03 673.849 1492.95 670.637 1496.58 667.109C1500.82 662.86 1504.67 658.245 1508.1 653.319C1511.95 647.879 1515.77 641.659 1519.6 635.479C1523.09 629.588 1526.94 623.911 1531.11 618.479C1534.33 614.324 1538.27 610.776 1542.73 607.999C1546.2 605.824 1550.21 604.67 1554.31 604.669C1555.77 604.711 1557.22 604.892 1558.64 605.209C1560.2 605.529 1561.77 605.839 1563.39 606.139C1566.39 606.689 1569.39 607.139 1572.39 607.549C1574.61 607.819 1576.86 608.049 1579.12 608.219C1581.38 608.389 1583.64 608.539 1585.96 608.639C1588.12 608.729 1590.22 608.789 1592.4 608.809C1596.21 608.809 1599.87 608.709 1603.66 608.429C1606.45 608.219 1609.14 607.949 1611.85 607.619C1614.77 607.279 1617.64 606.859 1620.33 606.389L1621.57 606.169C1624.05 605.709 1626.52 605.169 1628.82 604.609C1631.12 604.049 1633.24 603.429 1635.08 602.829C1636.64 602.319 1638.08 601.779 1639.23 601.339L1640.74 600.709C1642.49 599.939 1643.74 599.319 1645.07 598.639C1649.12 596.483 1653 594.005 1656.66 591.229C1660.53 588.339 1664.39 585.069 1668.25 581.579C1672.11 578.089 1675.97 574.359 1679.83 570.809C1683.69 567.259 1687.56 563.879 1691.41 560.939C1695.05 558.113 1698.93 555.611 1703 553.459C1706.65 551.521 1710.55 550.081 1714.58 549.179C1718.39 548.394 1722.29 548.168 1726.17 548.509C1730.03 548.829 1733.88 549.609 1737.73 550.269C1741.56 550.967 1745.43 551.441 1749.32 551.689C1753.19 551.952 1757.07 551.743 1760.89 551.069C1764.86 550.264 1768.74 549.072 1772.48 547.509C1776.34 545.969 1780.2 544.212 1784.05 542.239C1787.9 540.239 1791.77 538.069 1795.63 535.859C1799.49 533.649 1803.35 531.439 1807.21 529.219L1818.77 522.549L1830.36 515.859L1841.93 509.179L1853.51 502.489L1865.09 495.809L1876.67 489.119L1888.26 482.429L1899.83 475.749L1911.41 469.059L1923 462.369L1929.47 458.629"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1714.24 128.5L1679.78 148.39L1668.45 154.94L1656.81 161.66L1645.35 168.28L1633.77 175L1622 181.77L1610.43 188.45C1606.62 190.64 1602.91 192.79 1599.09 195L1587.5 201.67L1575.88 208.38L1564.24 215.1L1552.64 221.8L1541.05 228.49L1529.46 235.18L1517.88 241.87L1506.29 248.56L1494.72 255.24L1483.14 261.93L1471.55 268.62L1460 275.3L1448.39 282L1436.82 288.67C1432.94 290.89 1429.08 293.117 1425.24 295.35L1413.67 302L1402.09 308.69L1390.51 315.38L1379 322.08L1367.41 328.77L1355.83 335.46L1344.25 342.14L1332.68 348.82L1321 355.51L1309.43 362.19L1297.85 368.88L1286.27 375.56L1274.69 382.25L1263.11 388.94L1251.56 395.63L1243.5 400.28"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="20"
      fontWeight="800"
      letterSpacing="0em"
    >
      <tspan x="1593.05" y="426">
        IO
      </tspan>
    </text>
    <text
      fill="url(#paint2_linear_1112_12845)"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="76"
      fontWeight="800"
      letterSpacing="0em"
    >
      <tspan x="1519.04" y="499.6">
        48%
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="1566.2" y="530.8">
        Address:&#10;
      </tspan>
      <tspan x="1561.26" y="553.8">
        0x4553e0
      </tspan>
    </text>
    <g filter="url(#filter0_ddd_1112_12845)">
      <rect x="565" y="208" width="800" height="493" rx="12" fill="white" />
    </g>
    <rect opacity="0.1" x="565" y="471" width="800" height="24" fill="#FD0054" />
    <rect opacity="0.1" x="614" y="245" width="1" height="456" fill="#181A1B" />
    <text
      opacity="0.6"
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="589.592" y="276.938">
        1&#10;
      </tspan>
      <tspan x="589.592" y="297.938">
        2&#10;
      </tspan>
      <tspan x="589.592" y="318.938">
        3&#10;
      </tspan>
      <tspan x="589.592" y="339.938">
        4&#10;
      </tspan>
      <tspan x="589.592" y="360.938">
        5&#10;
      </tspan>
      <tspan x="589.592" y="381.938">
        6&#10;
      </tspan>
      <tspan x="589.592" y="402.938">
        7&#10;
      </tspan>
      <tspan x="589.592" y="423.938">
        8&#10;
      </tspan>
      <tspan x="589.592" y="444.938">
        9&#10;
      </tspan>
      <tspan x="581.184" y="465.938">
        10&#10;
      </tspan>
      <tspan x="581.184" y="486.938">
        11&#10;
      </tspan>
      <tspan x="581.184" y="507.938">
        12&#10;
      </tspan>
      <tspan x="581.184" y="528.938">
        13&#10;
      </tspan>
      <tspan x="581.184" y="549.938">
        14&#10;
      </tspan>
      <tspan x="581.184" y="570.938">
        15&#10;
      </tspan>
      <tspan x="581.184" y="591.938">
        16&#10;
      </tspan>
      <tspan x="581.184" y="612.938">
        17&#10;
      </tspan>
      <tspan x="581.184" y="633.938">
        18&#10;
      </tspan>
      <tspan x="581.184" y="654.938">
        19&#10;
      </tspan>
      <tspan x="581.184" y="675.938">
        20
      </tspan>
    </text>
    <path
      d="M565 220C565 213.373 570.373 208 577 208H1353C1359.63 208 1365 213.373 1365 220V244H565V220Z"
      fill="white"
    />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="600"
      letterSpacing="0em"
    >
      <tspan x="939.119" y="230.9">
        Haskell
      </tspan>
    </text>
    <circle cx="587" cy="226" r="6" fill="#FD0054" />
    <circle cx="607" cy="226" r="6" fill="#FFB31A" />
    <circle cx="627" cy="226" r="6" fill="#00CC21" />
    <rect opacity="0.1" x="565" y="244" width="800" height="1" fill="#181A1B" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="689.449" y="276.938">
        {' '}
      </tspan>
      <tspan x="840.797" y="276.938">
        {' '}
      </tspan>
      <tspan x="639" y="297.938" />
      <tspan x="731.49" y="318.938">
        {' '}
      </tspan>
      <tspan x="756.715" y="318.938">
        {' '}
        (
      </tspan>
      <tspan x="798.756" y="318.938">
        {' '}
        a){' '}
      </tspan>
      <tspan x="849.205" y="318.938">
        {' '}
        [a]{' '}
      </tspan>
      <tspan x="908.062" y="318.938">
        {' '}
        a{' '}
      </tspan>
      <tspan x="950.104" y="318.938">
        {' '}
      </tspan>
      <tspan x="983.736" y="318.938">
        {' '}
        -&#62;{' '}
      </tspan>
      <tspan x="639" y="339.938">
        bsWithIndex list n i&#10;
      </tspan>
      <tspan x="639" y="360.938">
        {' '}
      </tspan>
      <tspan x="681.041" y="360.938">
        {' '}
        n{' '}
      </tspan>
      <tspan x="723.082" y="360.938">
        {' '}
      </tspan>
      <tspan x="765.123" y="360.938">
        {' '}
        list{' '}
      </tspan>
      <tspan x="832.389" y="360.938">
        {' '}
      </tspan>
      <tspan x="874.43" y="360.938">
        {' '}
        i&#10;
      </tspan>
      <tspan x="639" y="381.938">
        {' '}
      </tspan>
      <tspan x="681.041" y="381.938">
        {' '}
        len{' '}
      </tspan>
      <tspan x="739.898" y="381.938">
        {' '}
      </tspan>
      <tspan x="756.715" y="381.938">
        {' '}
      </tspan>
      <tspan x="832.389" y="381.938">
        {' '}
      </tspan>
      <tspan x="899.654" y="381.938">
        {' '}
      </tspan>
      <tspan x="639" y="402.938">
        {' '}
      </tspan>
      <tspan x="681.041" y="402.938">
        {' '}
        n{' '}
      </tspan>
      <tspan x="714.674" y="402.938">
        {' '}
      </tspan>
      <tspan x="756.715" y="402.938">
        {' '}
        ys{' '}
      </tspan>
      <tspan x="832.389" y="402.938">
        {' '}
        bsWithIndex xs n i&#10;
      </tspan>
      <tspan x="639" y="423.938">
        {' '}
      </tspan>
      <tspan x="681.041" y="423.938">
        {' '}
      </tspan>
      <tspan x="765.123" y="423.938">
        {' '}
      </tspan>
      <tspan x="832.389" y="423.938">
        {' '}
        bsWithIndex ys n (i{' '}
      </tspan>
      <tspan x="1017.37" y="423.938">
        {' '}
        half)&#10;
      </tspan>
      <tspan x="639" y="444.938">
        {' '}
      </tspan>
      <tspan x="714.674" y="444.938" />
      <tspan x="639" y="465.938">
        {' '}
        len{' '}
      </tspan>
      <tspan x="798.756" y="465.938">
        {' '}
      </tspan>
      <tspan x="857.613" y="465.938">
        {' '}
        list&#10;
      </tspan>
      <tspan x="639" y="486.938">
        {' '}
        half{' '}
      </tspan>
      <tspan x="798.756" y="486.938">
        {' '}
        len{' '}
      </tspan>
      <tspan x="882.838" y="486.938">
        {' '}
      </tspan>
      <tspan x="899.654" y="486.938" />
      <tspan x="639" y="507.938">
        {' '}
        (xs, ys){' '}
      </tspan>
      <tspan x="798.756" y="507.938">
        {' '}
      </tspan>
      <tspan x="866.021" y="507.938">
        {' '}
        half list&#10;
      </tspan>
      <tspan x="639" y="528.938" />
      <tspan x="655.816" y="549.938">
        {' '}
      </tspan>
      <tspan x="681.041" y="549.938">
        {' '}
        (
      </tspan>
      <tspan x="723.082" y="549.938">
        {' '}
        a){' '}
      </tspan>
      <tspan x="773.531" y="549.938">
        {' '}
        [a]{' '}
      </tspan>
      <tspan x="832.389" y="549.938">
        {' '}
        a{' '}
      </tspan>
      <tspan x="874.43" y="549.938">
        {' '}
      </tspan>
      <tspan x="639" y="570.938">
        bs list n{' '}
      </tspan>
      <tspan x="773.531" y="570.938">
        {' '}
        bsWithIndex list n{' '}
      </tspan>
      <tspan x="950.104" y="570.938">
        {' '}
      </tspan>
      <tspan x="639" y="591.938">
        {' '}
      </tspan>
      <tspan x="706.266" y="591.938">
        {' '}
        x{' '}
      </tspan>
      <tspan x="756.715" y="591.938">
        {' '}
        x&#10;
      </tspan>
      <tspan x="639" y="612.938">
        {' '}
      </tspan>
      <tspan x="731.49" y="612.938">
        {' '}
      </tspan>
      <tspan x="639" y="633.938" />
      <tspan x="672.633" y="654.938">
        {' '}
      </tspan>
      <tspan x="697.857" y="654.938">
        {' '}
      </tspan>
      <tspan x="639" y="675.938">
        main{' '}
      </tspan>
    </text>
    <text
      fill="#FD0054"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="639" y="276.938">
        module
      </tspan>
      <tspan x="849.205" y="276.938">
        where&#10;
      </tspan>
      <tspan x="739.898" y="318.938">
        ::
      </tspan>
      <tspan x="832.389" y="318.938">
        =&#62;
      </tspan>
      <tspan x="891.246" y="318.938">
        -&#62;
      </tspan>
      <tspan x="933.287" y="318.938">
        -&#62;
      </tspan>
      <tspan x="672.633" y="360.938">
        |
      </tspan>
      <tspan x="706.266" y="360.938">
        ==
      </tspan>
      <tspan x="823.98" y="360.938">
        =
      </tspan>
      <tspan x="672.633" y="381.938">
        |
      </tspan>
      <tspan x="723.082" y="381.938">
        ==
      </tspan>
      <tspan x="823.98" y="381.938">
        =
      </tspan>
      <tspan x="672.633" y="402.938">
        |
      </tspan>
      <tspan x="706.266" y="402.938">
        &#60;
      </tspan>
      <tspan x="823.98" y="402.938">
        =
      </tspan>
      <tspan x="672.633" y="423.938">
        |
      </tspan>
      <tspan x="823.98" y="423.938">
        =
      </tspan>
      <tspan x="1008.96" y="423.938">
        +
      </tspan>
      <tspan x="672.633" y="444.938">
        where
      </tspan>
      <tspan x="790.348" y="465.938">
        =
      </tspan>
      <tspan x="790.348" y="486.938">
        =
      </tspan>
      <tspan x="840.797" y="486.938">
        `div`
      </tspan>
      <tspan x="790.348" y="507.938">
        =
      </tspan>
      <tspan x="664.225" y="549.938">
        ::
      </tspan>
      <tspan x="756.715" y="549.938">
        =&#62;
      </tspan>
      <tspan x="815.572" y="549.938">
        -&#62;
      </tspan>
      <tspan x="857.613" y="549.938">
        -&#62;
      </tspan>
      <tspan x="723.082" y="570.938">
        = case
      </tspan>
      <tspan x="958.512" y="570.938">
        of&#10;
      </tspan>
      <tspan x="739.898" y="591.938">
        -&#62;
      </tspan>
      <tspan x="739.898" y="612.938">
        -&#62; -
      </tspan>
      <tspan x="681.041" y="654.938">
        ::
      </tspan>
      <tspan x="681.041" y="675.938">
        = do
      </tspan>
    </text>
    <text
      fill="#001A9B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="697.857" y="276.938">
        Misc.BinarySearch
      </tspan>
      <tspan x="958.512" y="318.938">
        Int
      </tspan>
      <tspan x="1017.37" y="318.938">
        Maybe Int&#10;
      </tspan>
      <tspan x="731.49" y="360.938">
        head
      </tspan>
      <tspan x="748.307" y="381.938">
        1
      </tspan>
      <tspan x="723.082" y="402.938">
        head
      </tspan>
      <tspan x="689.449" y="423.938">
        otherwise
      </tspan>
      <tspan x="807.164" y="465.938">
        length
      </tspan>
      <tspan x="891.246" y="486.938">
        2
      </tspan>
      <tspan x="807.164" y="507.938">
        splitAt
      </tspan>
      <tspan x="882.838" y="549.938">
        Int&#10;
      </tspan>
      <tspan x="941.695" y="570.938">
        0
      </tspan>
      <tspan x="773.531" y="612.938">
        1&#10;
      </tspan>
      <tspan x="706.266" y="654.938">
        IO ()&#10;
      </tspan>
    </text>
    <text
      fill="#8152E0"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="639" y="318.938">
        bsWithIndex
      </tspan>
      <tspan x="773.531" y="318.938">
        Ord
      </tspan>
      <tspan x="639" y="549.938">
        bs
      </tspan>
      <tspan x="697.857" y="549.938">
        Ord
      </tspan>
      <tspan x="639" y="654.938">
        main
      </tspan>
    </text>
    <text
      fill="#1A9900"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="840.797" y="360.938">
        Just
      </tspan>
      <tspan x="840.797" y="381.938">
        Nothing
      </tspan>
      <tspan x="672.633" y="591.938">
        Just
      </tspan>
      <tspan x="672.633" y="612.938">
        Nothing
      </tspan>
    </text>
    <text
      fill="#798486"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="924.879" y="381.938">
        -- only candidate in list is not the right elem&#10;
      </tspan>
    </text>
    <g clipPath="url(#clip0_1112_12845)">
      <path d="M1273 681L1289 657L1273 633H1285L1301 657L1285 681" fill="#666666" />
      <path d="M1327.67 667L1322.33 659H1341V667" fill="#666666" />
      <path d="M1319.67 655L1314.33 647H1341V655" fill="#666666" />
      <path d="M1289 681L1305 657L1289 633H1301L1333 681H1321L1311 666L1301 681" fill="#999999" />
    </g>
    <path
      d="M1365 482.625L1473 482.625M1473 482.625L1461.38 473M1473 482.625L1461.37 492.25"
      stroke="#181A1B"
      strokeWidth="2"
    />
    <defs>
      <filter
        id="filter0_ddd_1112_12845"
        x="525"
        y="188"
        width="880"
        height="573"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1112_12845" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1112_12845"
          result="effect2_dropShadow_1112_12845"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1112_12845"
          result="effect3_dropShadow_1112_12845"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1112_12845"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1112_12845"
        x1="1729"
        y1="359"
        x2="1470.74"
        y2="370.189"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.248157" stopColor="#F14CFF" />
        <stop offset="0.873684" stopColor="#401AFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1112_12845"
        x1="1709"
        y1="379"
        x2="1492.4"
        y2="388.384"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.248157" stopColor="#F14CFF" />
        <stop offset="0.873684" stopColor="#401AFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1112_12845"
        x1="1690"
        y1="435"
        x2="1535.89"
        y2="536.618"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.202728" stopColor="#F14AFF" />
        <stop offset="0.888777" stopColor="#401AFF" />
      </linearGradient>
      <clipPath id="clip0_1112_12845">
        <rect width="68" height="48" fill="white" transform="translate(1273 633)" />
      </clipPath>
    </defs>
  </svg>
);

Haskell.propTypes = {
  className: PropTypes.string,
};

Haskell.defaultProps = {
  className: null,
};

export default Haskell;
